var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"detail"},[_c('div',{staticClass:"detail_center"},[_c('div',{staticClass:"detail_title"},[_vm._v(" "+_vm._s(_vm.globalHelp.getArticleDetail.title)+" ")]),_c('div',{staticClass:"detail_main v-html",domProps:{"innerHTML":_vm._s(_vm.globalHelp.getArticleDetail.content)}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }